import { useVehiclesDataWebSocket } from '@data/fms/vehicle/hooks';
import { useMount, useUnmount } from 'react-use';

const VehicleWebSocket = () => {
  const {
    createVehiclesTelemetrySocket,
    closeVehiclesTelemetrySocket,
    createVehiclesMetadataSocket,
    closeVehiclesMetadataSocket,
  } = useVehiclesDataWebSocket();

  useMount(async () => {
    await createVehiclesTelemetrySocket();
    await createVehiclesMetadataSocket();
  });

  useUnmount(() => {
    closeVehiclesTelemetrySocket();
    closeVehiclesMetadataSocket();
  });

  return <></>;
};

export default VehicleWebSocket;
